module.exports = __webpack_public_path__ + "b3f83c53aee27bba3805b4f28c958ee5.png";